// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"7cb00ba1","6655":"b0a8ffe5"}[chunkId] + ".chunk.css";
};